export default __webpack_public_path__ + "static/media/upload.7d086621.svg";